module.exports = __webpack_public_path__ + "static/media/survey-total-response-icon.ffe66b90.svg";